import { render } from "./DocVideo.vue?vue&type=template&id=31704f24&ts=true"
import script from "./DocVideo.vue?vue&type=script&lang=ts"
export * from "./DocVideo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__